export const TOPICS_REQUEST = "TOPIC_START";
export const TOPICS_SUCCESS = "TOPICS_SUCCESS";
export const TOPICS_FAIL = "TOPICS_FAIL";
export const TOPICS_GET_QUESTIONS_REQUEST = "TOPICS_GET_QUESTIONS_REQUEST";
export const TOPICS_GET_QUESTIONS_SUCCESS = "TOPICS_GET_QUESTIONS_SUCCESS";
export const GETALL_INTERVIEW_REQUEST = "GETALL_INTERVIEW_REQUEST";
export const GETALL_INTERVIEW_SUCCESS = "GETALL_INTERVIEW_SUCCESS";
export const GETCURR_INTERVIEW_SUCCESS = "GETCURR_INTERVIEW_SUCCESS";
export const GETCURR_INTERVIEW_REQUEST = "GETALL_INTERVIEW_REQUEST";
export const GETALL_COMPANIES_REQUEST = "GETALL_COMPANIES_REQUEST";
export const GETALL_COMPANIES_SUCCESS = "GETALL_COMPANIES_SUCCESS";
export const GET_COMPANY_INTERVIEW_REQUEST = "GET_COMPANY_INTERVIEW_REQUEST";
export const GET_COMPANY_INTERVIEW_SUCCESS = "GET_COMPANY_INTERVIEW_SUCCESS";
export const GET_COMMENT_SUCCESS = "GET_COMMENT_SUCCESS";
export const GET_COMMENT_REQUEST = "GET_COMMENT_REQUEST";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_REQUEST = "POST_COMMENT_REQUEST";
export const GETTOP_INTERVIEW_REQUEST = "GETTOP_INTERVIEW_REQUEST";
export const GETTOP_INTERVIEW_SUCCESS = "GETTOP_INTERVIEW_SUCCESS";
